//# sourceMappingURL=my-marked-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-marked-date.interface.js
// module id = 995
// module chunks = 3